export const selectOptionsTimeSinceHousingEvent = [
  "Within the last 12-months",
  "Within the last 2-years",
  "Greater than 2-years ago",
];
